export default "__VITE_ASSET__OCVcyoNb__"